// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__19Xng","title":"Info_title__2oy-x","links":"Info_links__146lm","link":"Info_link__3gYUC","logo":"Info_logo__2qEKZ"};